export enum ForgotPasswordEnum {
  FORM = 'form',
  INFO = 'info,'
}
